<button
  type="button"
  class="flex items-center gap-2 rounded border border-slate-300 px-3 py-1 text-sm dark:border-slate-700"
  (click)="onToggle()"
>
  <svg
    *ngIf="!isDark"
    class="h-4 w-4 text-amber-500"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <circle cx="12" cy="12" r="4" />
    <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
  </svg>
  <svg
    *ngIf="isDark"
    class="h-4 w-4 text-slate-200"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    stroke-width="2"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
  >
    <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z" />
  </svg>
  {{ isDark ? i18n.translate('theme.dark') : i18n.translate('theme.light') }}
</button>
